<div class="ws-popup-header">
    <span>{{'Choose the automations to activate' | translate}}</span>
    <div class="actions">
        <button (click)="closeClicked()" mat-icon-button>
            <mat-icon>close</mat-icon>
        </button>
    </div>
</div>

<div class="ws-popup-content">
    <div class="ws-popup-body">
        <div class="checkbox-container" *ngIf="!isAvailabilityBlock">
            <mat-checkbox (change)="toggleValue($event, 'closeSlots')" [disabled]="hasEnabledAutomations">
                {{'Close slots at the same time' | translate}}
            </mat-checkbox>
            <web-info-icon-hoverable [description]="
'This will close all slots for other experiences at the same time. This won\'t affect this experience\'s slots.'
| translate
" iconOverrides="margin-left: 8px;"></web-info-icon-hoverable>
        </div>
        <div class="checkbox-container" *ngIf="isAvailabilityBlock">
            <mat-checkbox (change)="toggleValue($event, 'openSlots')" [disabled]="hasEnabledAutomations">
                {{'Open slots at the same time' | translate}}
            </mat-checkbox>
            <web-info-icon-hoverable [description]="
        'This will open all slots for other experiences at the same time. This won\'t affect this experience\'s slots.'
        | translate
        " iconOverrides="margin-left: 8px;"></web-info-icon-hoverable>
        </div>
        <div class="checkbox-container" *ngIf="!isLanguageBlock">
            <mat-checkbox (change)="toggleValue($event, 'deactivateOtherLangs')" [disabled]="hasEnabledAutomations">
                {{'Deactivate different languages' | translate}}
            </mat-checkbox>
            <web-info-icon-hoverable [description]="
        'This will deactivate every language for this slot except the one selected for the current reservation. This won\'t affect the other experiences\' slots.'
        | translate
        " iconOverrides="margin-left: 8px;"></web-info-icon-hoverable>
        </div>
        <div class="checkbox-container" *ngIf="isLanguageBlock">
            <mat-checkbox (change)="toggleValue($event, 'activateOtherLangs')" [disabled]="hasEnabledAutomations">
                {{'Activate different languages' | translate}}
            </mat-checkbox>
            <web-info-icon-hoverable [description]="
        'This will activate every language available for this slot. This won\'t affect the other experiences\' slots.'
        | translate
        " iconOverrides="margin-left: 8px;"></web-info-icon-hoverable>
        </div>
    </div>
    <div *ngIf="hasEnabledAutomations" class="info-message">
        <mat-icon>info</mat-icon>
        <span>{{"These options are being handled by the active automations" | translate}}</span>
    </div>
    <div class="ws-popup-footer">
        <span></span>
        <div class="actions-wrapper">
            <ws-button (click)="closeClicked()" [callToActionType]="'tertiary'">
                {{'Cancel' | translate}}
            </ws-button>
            <ws-button (click)="confirmClicked()" [callToActionType]="'primary'">
                {{'Confirm' | translate}}
            </ws-button>
        </div>
    </div>
</div>